export default {"src":"/_next/static/media/profile-weakness.ed2e318d.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};